// extracted by mini-css-extract-plugin
module.exports = {"signupBlockFooter":"signupBlockFooter-UbLDw","btnSignupFooter":"btnSignupFooter-yKzQM","signupBlockFooterMobile":"signupBlockFooterMobile-ryxg0"};